import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import PageLayout from '../../components/PageLayout'
import apiRest from '../../services/apiRest'
import { StoreState } from '../../store'
import { getTransactions } from '../../store/transactions/transactionsActions'
import { TransactionsActionTypes } from '../../store/transactions/transactionsTypes'
import TransactionsDetails from './TransactionsDetails'
import TransactionsList from './TransactionsList'
import TransactionsMain from './TransactionsMain'
import TransactionsToolbar from './TransactionsToolbar'

export default function Transactions() {
  const { isEditing, churchId, selectedIndex } = useSelector(
    ({ transactionsState, sessionState }: StoreState) => ({
      isEditing: transactionsState.isEditing,
      churchId:
        sessionState.user?.churches[sessionState.selectedChurchIndex]?.id,
      selectedIndex: transactionsState.selectedIndex,
    })
  )

  const dispatch = useDispatch()
  const onMountPage = () => dispatch(getTransactions())
  const onUnmountPage = () => dispatch({ type: TransactionsActionTypes.CLEAR })

  const [people, setPeople] = useState([])
  const [categories, setCategories] = useState([])
  useEffect(() => {
    ;(async () => {
      if (!churchId) {
        return
      }
      const { data: dataPeople } = await apiRest.get('/people', {
        params: {
          churchId,
          fields: 'id,name',
          status: 'all',
          gender: 'all',
          under_age: 'false',
        },
      })
      const { data: dataCategories } = await apiRest.get(
        '/transactions/categories',
        {
          params: { churchId, fields: 'id,name' },
        }
      )
      setPeople(dataPeople)
      setCategories(dataCategories)
    })()
  }, [churchId])

  return (
    <PageLayout
      toolbar={
        <TransactionsToolbar
          key={String(selectedIndex)}
          {...{ people, categories }}
        />
      }
      list={<TransactionsList />}
      details={
        <TransactionsDetails
          key={String(selectedIndex)}
          {...{ people, categories }}
        />
      }
      detailsPlaceholder={<TransactionsMain />}
      paperPlaceholder
      hideDetails={!isEditing}
      onMountPage={onMountPage}
      onUnmountPage={onUnmountPage}
    />
  )
}
